import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { AppLayoutSecureService } from './secure.service';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';

@Component({
  selector: 'app-layout-secure',
  templateUrl: './secure.component.html',
  styleUrls: ['./secure.component.scss'],
  animations: [
    trigger('toggleContent', [
      state('true', style({ transform: 'translateX(300px)' })),
      state('false', style({ transform: 'translateX(0%)' })),
      transition('true <=> false', animate('0.3s ease-out')),
    ]),
    trigger('toggleSide', [
      state('true', style({ transform: 'translateX(0)' })),
      state('false', style({ transform: 'translateX(-1000%)' })),
      transition('true <=> false', animate('0.3s ease-out')),
    ]),
  ],
})
export class AppLayoutSecureComponent {
  isShow = false;

  constructor(
    private _appLayoutSecureSrv: AppLayoutSecureService,
    private _cd: ChangeDetectorRef
  ) {}

  get sideEndOpened() {
    return this._appLayoutSecureSrv.sideEndOpened;
  }

  set sideEndOpened(sideEndOpened) {
    this._appLayoutSecureSrv.sideEndOpened = sideEndOpened;
  }

  @ViewChild(MatSidenavContent)
  set matSidenavContent(matSidenavContent: MatSidenavContent | undefined) {
    this._appLayoutSecureSrv.matSidenavContent = matSidenavContent;
  }

  @ViewChild('sideStart')
  set matSide(matSidenav: MatSidenav | undefined) {
    this._appLayoutSecureSrv.matSidenav = matSidenav;
  }

  scrollToTop() {
    this._appLayoutSecureSrv.matSidenavContent
      ?.getElementRef()
      .nativeElement.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
  }
}
